import { createContext, useState, useEffect, useContext } from "react";
import { checkAuthStatus, logoutRequest } from "../api/auth";
import toast from "react-hot-toast";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const init = async () => {
            try {
                const userData = await checkAuthStatus();
                setUser(userData);
            } catch {
                setUser(null);
            } finally {
                setLoading(false);
            }
        };
        init();
    }, []);

    const logout = async () => {
        try {
            await logoutRequest();
        } catch (err) {
            toast.error("خروج ناموفق، دوباره تلاش کنید!")
        } finally {
            setUser(null);
        }
    };

    return (
        <AuthContext.Provider value={{ user, setUser, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);